export const CACHE_FRESH_TIME = 5 * 60 * 1000;
export const CACHE_RETENTION_TIME = 5 * 60 * 1000;
//# sourceMappingURL=constants.js.map